import { StaticHero } from '../components'
import { CardDescription } from '../components'
import { Contact } from '../components'
import { ExperienceCards } from '../components'
import { TeamArea } from '../components'

const About = () => {
	return (
		<>
			<StaticHero />
			<CardDescription />
			<ExperienceCards />
			<TeamArea />
			<Contact />
		</>
	)
}

export default About
